<template>
    <span>
        <how-we-counted></how-we-counted>
        <foot-section></foot-section>
    </span>
</template>
<script>
import HowWeCounted from "@/components/HowWeCounted";
import FootSection from "@/components/FootSection";
export default {
    name: "about",
    components: {
        HowWeCounted,
        FootSection
    }
};
</script>